/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Aai20Traverser } from '../../asyncapi/v2/visitors/Aai20Traverser';
import { IAai20Visitor } from '../../asyncapi/v2/visitors/IAai20Visitor';
import { CombinedReverseTraverser } from '../../combined/visitors/CombinedReverseTraverser';
import { Document } from '../models/Document';
import { ITraverser } from '../visitors/ITraverser';
import { IVisitor } from '../visitors/IVisitor';
import { TraverserDirection } from '../visitors/TraverserDirection';
import { IOas20Visitor } from '../../openapi/v2/visitors/IOas20Visitor';
import { Oas20Traverser } from '../../openapi/v2/visitors/Oas20Traverser';
import { IOas30Visitor } from '../../openapi/v3/visitors/IOas30Visitor';
import { Oas30Traverser } from '../../openapi/v3/visitors/Oas30Traverser';
import { DocumentType } from '../models/DocumentType';

/**
 * Creates a traverser for a particular data model.
 * 
 * @author eric.wittmann@gmail.com
 * @class
 */
export class TraverserFactory {
    /**
     * Create the appropriate traverser for the given document/data model.
     * 
     * @param {Document} doc
     * @param {*} visitor
     * @param {TraverserDirection} direction
     * @return {*}
     */
    public static create(doc : Document, visitor : IVisitor, direction : TraverserDirection) : ITraverser {
        if(direction == null) {
            direction = TraverserDirection.down;
        }
        switch((doc.getDocumentType())) {
        case DocumentType.asyncapi2:
            return direction === TraverserDirection.down?new Aai20Traverser(<IAai20Visitor><any>visitor):new CombinedReverseTraverser(<IAai20Visitor><any>visitor);
        case DocumentType.openapi2:
            return direction === TraverserDirection.down?new Oas20Traverser(<IOas20Visitor><any>visitor):new CombinedReverseTraverser(<IOas20Visitor><any>visitor);
        case DocumentType.openapi3:
            return direction === TraverserDirection.down?new Oas30Traverser(<IOas30Visitor><any>visitor):new CombinedReverseTraverser(<IOas30Visitor><any>visitor);
        default:
            throw Object.defineProperty(new Error("Failed to create a traverser for document type: " + doc.getDocumentType()), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
        }
    }
}
TraverserFactory["__class"] = "io.apicurio.datamodels.core.factories.TraverserFactory";



